import React, { useEffect, useState } from 'react';
import {
  Alert,
  AlertIcon,
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Select,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Radio,
  RadioGroup,
} from '@chakra-ui/react';
import {
  getBackendAssetURL,
  getBackendURL,
  getBackendURLWithSuffix,
  getSubRoutePath,
  setAndClear,
  apiFetch,
} from '../../../utils/utils';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function AddUserPage() {
  let navigate = useNavigate();
  const user = useSelector(state => state.userState.user);


  const [userSelectedPlan, setUserSelectedPlan] = useState('');
  const [userAmount, setUserAmount] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('OFFLINE');
  const [userPaymentTrackingNumber, setUserTrackingNumber] = useState('');
  const [plans, setPlans] = useState([]);
  const [email, setEmail] = useState('');

  const [category, setCategory] = useState();
  const [selectedCtegory, setSelectedCtegory] = useState();
  const [address, setAddress] = useState();
  const [pinCode, setPinCode] = useState();
  const [numberOfMonths, setumberOfMonths] = useState(0);
  const [qrCodeImg, setQrCodeImg] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [paymentGatewayEnabled, setPaymentGatewayEnabled] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [inProgress, setInProgress] = useState(false);

  useEffect(() => {
    fetchPlans();
    fetchCategories();
    fetchSettings();
  }, []);

  const fetchSettings = () => {
    apiFetch(`${getBackendURL()}/admin/settings`)
      .then(res => res.json())
      .then(data => {
        console.log(data);
        if (data.qrCodePath) {
          setQrCodeImg(data.qrCodePath.startsWith('http') ? data.qrCodePath : `${getBackendAssetURL()}/${data.qrCodePath}`);
        }
        if (data.paymentGatewayEnabled === false) {
          setPaymentGatewayEnabled(false);
          setPaymentMethod('OFFLINE');
        }
      })
      .catch(err => console.error('Error fetching settings:', err));
  };

  const fetchPlans = () => {
    apiFetch(
      `${getBackendURL()}/${getSubRoutePath(user)}/merchant/plans?ownerId=${user._id}`
    )
      .then(response => response.json())
      .then(response => {
        if (response !== null && response.plans.length > 0) {
          let plans = [];
          response.plans.forEach(plan => {
            plans.push({
              id: plan._id,
              name: plan.name,
              price: plan.price,
              numberOfMonths: plan.numberOfMonths,
            });
          });
          setPlans(plans);
        } else {
          setPlans([]);
        }
      })
      .catch(error => {
        console.log(error);
        setPlans([]);
      });
  };

  const fetchCategories = () => {
    apiFetch(
      `${getBackendURL()}/${getSubRoutePath(user)}/merchant/categories`
    )
      .then(response => response.json())
      .then(response => {
        if (response !== null && response.categories.length > 0) {
          setCategory(response.categories);
        } else {
          setPlans([]);
        }
      })
      .catch(error => {
        console.log(error);
        setPlans([]);
      });
  };

  const isEmpty = val => {
    return val === undefined || val === '' || val === 0;
  };

  // Removed sendPaymentLink as it will happen on onSubmit for ONLINE

  const onSubmit = () => {
    setError('');
    if (
      isEmpty(email) ||
      isEmpty(userSelectedPlan.id) ||
      isEmpty(selectedCtegory) ||
      isEmpty(address) ||
      isEmpty(pinCode) ||
      isEmpty(numberOfMonths) ||
      isEmpty(userSelectedPlan.id)
    ) {
      setError('Please set the proper details');
      return;
    }
    if (email.indexOf('@gmail.com') === -1) {
      setError('Please use the gmail account');
      return;
    }
    setInProgress(true);
    apiFetch(
      `${getBackendURL()}/${getSubRoutePath(user)}/merchant/merchants/add`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          category: selectedCtegory,
          address,
          pinCode,
          planId: userSelectedPlan.id,
          planName: userSelectedPlan.planName,
          numberOfMonths: numberOfMonths,
          ownerId: user._id,
          paymentDetailsId: userPaymentTrackingNumber,
          paymentMethod: paymentMethod,
        }),
      }
    )
      .then(response => response.json())
      .then(response => {
        setInProgress(false);
        if (response.merchant) {
          setAndClear(response.message, setSuccess);
          setTimeout(() => {
            navigate('/merchants');
          }, 1000);
        } else {
          setAndClear(response.message, setError);
        }

        setUserSelectedPlan({});
        setUserAmount(0);
        setUserTrackingNumber('');
      })
      .catch(error => {
        console.log(error);
        setInProgress(false);
        setAndClear(error, setError);
      });
  };

  const setSelectedPlan = id => {
    if (!id) {
      setUserSelectedPlan({});
      setUserAmount(0);
      setumberOfMonths(0);
      return;
    }
    let plan = plans.find(plan => plan.id === id);
    if (plan) {
      setUserAmount(plan.price);
      setumberOfMonths(plan.numberOfMonths);
      setUserSelectedPlan(plan);
    }
  };

  return (
    <>
      <Breadcrumb marginTop={2} marginLeft={2}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/">
            Home
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/merchants">
            Merchants
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/merchants/add">
            Add
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Stack mt={4} direction={{ base: 'column', lg: 'row' }}>
        <Box w={'100%'}>
          <Card
            bg={useColorModeValue('white', 'gray.700')}
            data-testid="add-plan-form-card"
          >
            <CardHeader>
              <Heading size="md">{'Add Merchant'}</Heading>
            </CardHeader>
            <Divider />
            <CardBody>
              <Alert status="success" display={success ? 'flex' : 'none'}>
                <AlertIcon />
                {success}
              </Alert>
              <Alert status="error" display={error ? 'flex' : 'none'}>
                <AlertIcon />
                {error}
              </Alert>
              <Stack spacing="4" mt="2">
                <Stack spacing={2} direction={{ base: 'column', lg: 'row' }}>
                  <FormControl isRequired>
                    <FormLabel>Email</FormLabel>
                    <Input
                      type="email"
                      id="email"
                      name="email"
                      value={email}
                      onChange={event => setEmail(event.target.value)}
                    />
                    <FormHelperText>Please use Google email.</FormHelperText>
                  </FormControl>
                </Stack>
                <Stack spacing={2} direction={{ base: 'column', lg: 'row' }}>
                  <FormControl isRequired>
                    <FormLabel>Address</FormLabel>
                    <Input
                      type="text"
                      id="address"
                      name="address"
                      value={address}
                      onChange={event => setAddress(event.target.value)}
                    />
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Pin Code</FormLabel>
                    <Input
                      type="number"
                      id="pinCode"
                      name="pinCode"
                      value={pinCode}
                      onChange={event => setPinCode(event.target.value)}
                    />
                  </FormControl>
                </Stack>

                <Stack spacing={2} direction={{ base: 'column', lg: 'row' }}>
                  <FormControl isRequired>
                    <FormLabel>Category</FormLabel>
                    <Select
                      placeholder="Select Category"
                      onChange={event => setSelectedCtegory(event.target.value)}
                    >
                      {category &&
                        category.length > 0 &&
                        category.map((categoryName, _index) => {
                          return (
                            <option key={_index} value={categoryName}>
                              {categoryName}
                            </option>
                          );
                        })}
                    </Select>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Plan Name</FormLabel>
                    <Select
                      placeholder="Select Plan"
                      onChange={event => setSelectedPlan(event.target.value)}
                    >
                      {plans.map(plan => {
                        return (
                          <option key={plan.id} value={plan.id}>
                            {plan.name} (Rs.{plan.price})
                          </option>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Payment Method</FormLabel>
                    <RadioGroup onChange={setPaymentMethod} value={paymentMethod}>
                      <Stack direction="row" spacing={5}>
                        <Radio value="OFFLINE">Offline Payment</Radio>
                        <Radio value="ONLINE" isDisabled={!paymentGatewayEnabled}>Online Payment</Radio>
                      </Stack>
                    </RadioGroup>
                  </FormControl>
                  {paymentMethod === 'OFFLINE' && (
                    <FormControl>
                      <FormLabel>Offline QR Code</FormLabel>
                      <Button colorScheme="blue" variant="outline" onClick={onOpen} isDisabled={userAmount === 0} size="sm">
                        Show QR Code
                      </Button>
                    </FormControl>
                  )}
                </Stack>

                <Stack spacing={2} direction={{ base: 'column', lg: 'row' }}>
                  <FormControl isRequired>
                    <FormLabel>Amount</FormLabel>
                    <Input
                      type="number"
                      id="amount"
                      name="amount"
                      value={userAmount}
                      disabled
                      onChange={event => setUserAmount(event.target.value)}
                    />
                    <FormHelperText>
                      {userSelectedPlan.price !== undefined
                        ? `Please collect the amount of ${userSelectedPlan.price}`
                        : 'Plan price'}
                    </FormHelperText>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Plan Duration</FormLabel>
                    <Input
                      type="number"
                      id="amount"
                      name="amount"
                      value={numberOfMonths}
                      disabled
                      onChange={event => setumberOfMonths(event.target.value)}
                    />
                    <FormHelperText> Plan Duration in Months </FormHelperText>
                  </FormControl>
                  <FormControl isRequired={paymentMethod === 'OFFLINE'}>
                    <FormLabel>Payment Tracking Id</FormLabel>
                    <Input
                      type="text"
                      id="trackingId"
                      name="trackingId"
                      value={userPaymentTrackingNumber}
                      isDisabled={paymentMethod === 'ONLINE'}
                      placeholder={paymentMethod === 'ONLINE' ? 'Auto-generated' : 'Enter tracking ID'}
                      onChange={event =>
                        setUserTrackingNumber(event.target.value)
                      }
                    />
                    <FormHelperText>
                      {paymentMethod === 'ONLINE'
                        ? 'Payment link will be sent to the merchant.'
                        : 'Enter the tracking ID from the offline payment.'}
                    </FormHelperText>
                  </FormControl>
                </Stack>
                {paymentMethod === 'ONLINE' && (
                  <Box p={4} borderWidth={1} borderRadius="md" textAlign="center" bg="blue.50" borderColor="blue.200">
                    <Text fontWeight="bold" color="blue.700">Online payment link will be sent to: {email || 'merchant email'}</Text>
                    <Text fontSize="sm" color="blue.600">The link will be generated and sent automatically upon adding the merchant.</Text>
                  </Box>
                )}
              </Stack>
            </CardBody>

            <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Scan to Pay</ModalHeader>
                <ModalCloseButton />
                <ModalBody textAlign="center">
                  <Text fontWeight="bold" mb={4}>Amount: Rs. {userAmount}</Text>
                  <Box p={4} bg="gray.100" borderRadius="md" display="inline-block">
                    <Box w="200px" h="200px" bg="white" display="flex" alignItems="center" justifyContent="center">
                      <img
                        src={qrCodeImg}
                        alt="QR Code"
                        style={{ maxWidth: '100%', maxHeight: '100%' }}
                      />
                    </Box>
                  </Box>
                  <Text mt={4} fontSize="sm" color="gray.500">Scan this QR code with any UPI app to complete the payment.</Text>
                </ModalBody>
                <ModalFooter>
                  <Button colorScheme="blue" mr={3} onClick={onClose}>
                    Done
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>

            <Divider />
            <CardFooter>
              <ButtonGroup spacing="2">
                <Button
                  variant="solid"
                  colorScheme="teal"
                  onClick={onSubmit}
                  isLoading={inProgress}
                  loadingText="Submitting..."
                >
                  Add
                </Button>
              </ButtonGroup>
            </CardFooter>
          </Card>
        </Box>
      </Stack>
    </>
  );
}

export default AddUserPage;
